import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import Slider from '../components/Slider'
import { db } from '../firebase';
import ListingItem from '../components/ListingItem';
import { Link } from 'react-router-dom';

const Home = () => {
  const [offerListing,setOfferListing] = useState(null);
  const [rentListing,setRentListing] = useState(null);
  const [saleListing,setSaleListing] = useState(null);



  useEffect(()=>{
    const fetchListings = async () => {

        try {

          const listingRef = collection(db,"listings");

          const q = query(listingRef,where("offer","==",true),orderBy("timestamp","desc"),limit(4));
          const rentq = query(listingRef,where("type","==","rent"),orderBy("timestamp","desc"),limit(4));
          const saleq = query(listingRef,where("type","==","sale"),orderBy("timestamp","desc"),limit(4));



          const querySnap = await getDocs(q);
          const rentquerySnap = await getDocs(rentq);
          const salequerySnap = await getDocs(saleq);
          const listings=[];
          const rentListings=[];
          const saleListings=[]

          querySnap.forEach((doc)=>{

            return listings.push({
              id:doc.id,
              data:doc.data()
            })

          });

          rentquerySnap.forEach((doc)=>{

            return rentListings.push({
              id:doc.id,
              data:doc.data()
            })

          });

          salequerySnap.forEach((doc)=>{

            return saleListings.push({
              id:doc.id,
              data:doc.data()
            })

          });

          setOfferListing(listings);
          setRentListing(rentListings);
          setSaleListing(saleListings);
          
        } catch (error) {
          console.log(error);
        }


    }
    fetchListings();
  },[])


  return (
    <div>
    <Slider />
    <div className="max-w-6xl mx-auto pt-4 space-y-6">
      {offerListing && offerListing.length>0 && (
        <div className="m-2 mb-6">
          <h2 className="px-3 text-2xl mt-6 font-semibold">
            Recent Offers</h2>
            <Link to="/offers">
              <p className="px-3 text-sm text-blue-600 hover:text-blue-700 transition duration-150
              ease-in-out">Show more offers</p>
            </Link>
            <ul className="sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {offerListing.map((listing)=>(
                <ListingItem key={listing.id} listing={listing.data} id={listing.id}/>
              ))}
            </ul>
          
        </div>
      )}


      {rentListing && rentListing.length>0 && (
        <div className="m-2 mb-6">
          <h2 className="px-3 text-2xl mt-6 font-semibold">
            Places for Rent</h2>
            <Link to="/category/rent">
              <p className="px-3 text-sm text-blue-600 hover:text-blue-700 transition duration-150
              ease-in-out">Show more places for Rent</p>
            </Link>
            <ul className="sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {rentListing.map((listing)=>(
                <ListingItem key={listing.id} listing={listing.data} id={listing.id}/>
              ))}
            </ul>
          
        </div>
      )}

      {saleListing && saleListing.length>0 && (
        <div className="m-2 mb-6">
          <h2 className="px-3 text-2xl mt-6 font-semibold">
            Places for Sale</h2>
            <Link to="/category/sale">
              <p className="px-3 text-sm text-blue-600 hover:text-blue-700 transition duration-150
              ease-in-out">Show more places for Sale</p>
            </Link>
            <ul className="sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {saleListing.map((listing)=>(
                <ListingItem key={listing.id} listing={listing.data} id={listing.id}/>
              ))}
            </ul>
          
        </div>
      )}
    </div>
    </div>
  )
}

export default Home